(function(){
    angular
        .module('app')
        .directive('ngTimepicker', timepicker);

        timepicker.$inject = ['$timeout'];
        function timepicker($timeout){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    element.bootstrapMaterialDatePicker({ switchOnClick : true,lang : 'es', weekStart : 1, cancelText : 'CANCELAR', format : 'HH:mm', date: false });
                });
            }
          }
      }
})();